module.exports = __webpack_public_path__ + "img/9788994475066.58c85b09.jpg";